import { SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN } from '@sentry/core';

/** Adds an origin to an OTEL Span. */
function addOriginToSpan(span, origin) {
  span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, origin);
}

export { addOriginToSpan };
//# sourceMappingURL=addOriginToSpan.js.map
